const steps = [
  {
    number: "I",
    title: "Tell us what's going on",
    description: "Say it in plain words. No agenda, no judgment.",
    accentVar: "--lens-krishna",
  },
  {
    number: "II",
    title: "Choose a lens",
    description: "The Bhagavad Gita, Chanakya, Vidur, or Ramayan lens — each thinks from a different tradition.",
    accentVar: "--marigold",
  },
  {
    number: "III",
    title: "Get one clear next step",
    description: "A grounded view, one practical action, and a clean summary you can return to.",
    accentVar: "--marigold",
  },
];

export default function HowItWorksScene() {
  return (
    <section
      className="home-band px-5 sm:px-8"
      style={{ background: "hsl(var(--ink))" }}
    >
      <div className="max-w-4xl mx-auto w-full text-left">
        <p className="scroll-reveal section-eyebrow">How it works</p>

        <h2 className="scroll-reveal section-heading mt-3">
          Three steps. One clear answer.
        </h2>

        <ol className="mt-10 sm:mt-14 relative">
          {/* vertical connector line */}
          <span
            aria-hidden
            className="absolute left-[18px] sm:left-[22px] top-3 bottom-3 w-px"
            style={{
              background: "linear-gradient(180deg, hsl(var(--marigold) / 0.5), hsl(var(--manuscript) / 0.18), transparent)",
            }}
          />

          {steps.map((step) => {
            const accent = `hsl(var(${step.accentVar}))`;
            return (
              <li
                key={step.title}
                className="scroll-reveal relative pl-12 sm:pl-16 pb-8 last:pb-0"
              >
                <span
                  className="absolute left-0 top-0 flex items-center justify-center rounded-full font-display"
                  style={{
                    width: 36,
                    height: 36,
                    fontSize: "0.9rem",
                    color: accent,
                    background: "hsl(var(--ink))",
                    border: `1px solid ${accent}55`,
                  }}
                >
                  {step.number}
                </span>
                <h3
                  className="font-display text-manuscript"
                  style={{ fontSize: "clamp(1.15rem, 1.8vw, 1.5rem)" }}
                >
                  {step.title}
                </h3>
                <p className="text-manuscript/60 text-sm sm:text-[15px] mt-1.5 leading-relaxed max-w-md">
                  {step.description}
                </p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
